import { ref, defineComponent } from 'vue';
import { GAP } from './utils';
import Thumb from './thumb';
export const barProps = () => ({
    always: {
        type: Boolean,
        default: true,
    },
    width: String,
    height: String,
    ratioX: {
        type: Number,
        default: 1,
    },
    ratioY: {
        type: Number,
        default: 1,
    },
});
const Bar = defineComponent({
    props: barProps(),
    setup(props, { expose }) {
        const moveX = ref(0);
        const moveY = ref(0);
        const handleScroll = (wrap) => {
            if (wrap) {
                const offsetHeight = wrap.offsetHeight - GAP;
                const offsetWidth = wrap.offsetWidth - GAP;
                moveY.value = ((wrap.scrollTop * 100) / offsetHeight) * props.ratioY;
                moveX.value = ((wrap.scrollLeft * 100) / offsetWidth) * props.ratioX;
            }
        };
        expose({
            handleScroll,
        });
        return () => {
            const { ratioX, ratioY, width, height, always } = props;
            return (<>
          <Thumb move={moveX.value} ratio={ratioX} size={width} always={always}/>
          <Thumb move={moveY.value} ratio={ratioY} size={height} vertical always={always}/>
        </>);
        };
    },
});
export default Bar;
